@if (displayAsAlert !== false) {
  @if (showErrors) {
    <ngb-alert [class]="alertClass" [dismissible]="false" type="danger">
      <ng-container [ngTemplateOutlet]="list"></ng-container>
    </ngb-alert>
  }
} @else {
  <ng-container [ngTemplateOutlet]="list" />
}

<ng-template #list>
  <ul class="list-unstyled mb-0">
    <!-- email -->
    <ng-container
      *ngTemplateOutlet="
        message;
        context: { defaultMessage: 'general.form.message.email', errors: errors, name: 'email' }
      "
    ></ng-container>

    <!-- required -->
    <ng-container
      *ngTemplateOutlet="
        message;
        context: { defaultMessage: 'general.form.message.required', errors: errors, name: 'required' }
      "
    ></ng-container>

    <!-- pattern -->
    <ng-container
      *ngTemplateOutlet="
        message;
        context: { defaultMessage: 'general.form.message.pattern', errors: errors, name: 'pattern' }
      "
    ></ng-container>

    <!-- min length -->
    <ng-container
      *ngTemplateOutlet="
        message;
        context: { defaultMessage: 'general.form.message.minlength', errors: errors, name: 'minlength' }
      "
    ></ng-container>

    <!-- max length -->
    <ng-container
      *ngTemplateOutlet="
        message;
        context: { defaultMessage: 'general.form.message.maxlength', errors: errors, name: 'maxlength' }
      "
    ></ng-container>

    <!-- min value -->
    <ng-container
      *ngTemplateOutlet="
        message;
        context: { defaultMessage: 'general.form.message.min', errors: errors, name: 'min' }
      "
    ></ng-container>

    <!-- max value -->
    <ng-container
      *ngTemplateOutlet="
        message;
        context: { defaultMessage: 'general.form.message.max', errors: errors, name: 'max' }
      "
    ></ng-container>

    <!-- not equals -->
    <ng-container
      *ngTemplateOutlet="
        message;
        context: { defaultMessage: 'general.form.message.equal', errors: errors, name: 'equal' }
      "
    ></ng-container>

    <!-- not equals -->
    <ng-container
      *ngTemplateOutlet="
        message;
        context: { defaultMessage: 'general.notEqual', errors: errors, name: 'notEqual' }
      "
    ></ng-container>

    <!-- duplicate -->
    <ng-container
      *ngTemplateOutlet="
        message;
        context: { defaultMessage: 'general.duplicate', errors: errors, name: 'duplicate' }
      "
    ></ng-container>

    <!-- any of required -->
    @if (errors !== null && errors.anyOfRequired !== undefined) {
      <li>
        <ng-container *ngTemplateOutlet="customMessage('anyOfRequired') || requireAnyDefault"></ng-container>
        <ng-template #requireAnyDefault>
          <span
            [innerHTML]="
              'general.form.message.anyOfRequired'
                | portalTranslate: { value: translateAnyOfRequiredValues(errors.anyOfRequired) }
            "
          >
          </span>
        </ng-template>
      </li>
    }
  </ul>

  <!-- custom validation error handling -->
  @if (customErrors.length > 0) {
    @if (customErrors.length > 1) {
      <ul class="list-unstyled mb-0">
        @for (error of customErrors; track error) {
          <li>
            <ng-container
              *ngTemplateOutlet="customMessage(error.key) || plainErrorCustom; context: { $implicit: error }"
            ></ng-container>
            <ng-template #plainErrorCustom>
              {{ error.value }} {{ error.key | translate: error.value }}
            </ng-template>
          </li>
        }
      </ul>
    } @else {
      <ng-container
        *ngTemplateOutlet="
          customMessage(customErrors[0].key) || plainErrorSimple;
          context: { $implicit: customErrors[0] }
        "
      ></ng-container>
      <ng-template #plainErrorSimple>
        <div>{{ customErrors[0].key | translate: customErrors[0].value }}</div>
      </ng-template>
    }
  }

  <!-- Template that allows overriding an error -->
  <ng-template #message let-defaultMessage="defaultMessage" let-errors="errors" let-name="name">
    @if (errors && errors[name]) {
      <li>
        <ng-container
          *ngTemplateOutlet="
            customMessage(name) || defaultMessageTemplate;
            context: { $implicit: errors[name] }
          "
        ></ng-container>
      </li>
    }

    <ng-template #defaultMessageTemplate let-context>
      {{ defaultMessage | portalTranslate: context }}
    </ng-template>
  </ng-template>
</ng-template>
